var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "p-1", class: _vm.className }, [
    _c("span", { staticClass: "small-card__title" }, [
      _vm._v(_vm._s(_vm.title)),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }